<a href="Javascript://">
    <h6 class="outer">
        <ng-content></ng-content>
        <div [ngClass]="isActive ? 'text-white bg-primary' : ''" class="inner-text pl-2 pr-2 rounded-pill"
            (click)="onClickSubdomain()">
            <span [title]="subdomain?.Label">{{subdomain?.Label}}</span>
        </div>
        <app-observation-comments-indicator class="ml-2 inner"
            [domainFilterId]="subdomain?.Value"></app-observation-comments-indicator>
        <app-observation-focus-area-indicator *ngIf="showFocusAreas" class="ml-2 inner" [isFocusArea]="isFocusArea" [readonly]="readonly"
            (onClickFocus)="onClickFocusArea($event)"></app-observation-focus-area-indicator>
    </h6>
</a>